import React from "react";
import { useTranslation } from "react-i18next";

const wrapperStyle = { textAlign: "center", padding: "20px" };
const buttonStyle = (isLoading) => ({
  backgroundColor: "#6F9CEB",
  color: "white",
  border: "none",
  padding: "10px 20px",
  borderRadius: "4px",
  cursor: isLoading ? "not-allowed" : "pointer",
  opacity: isLoading ? 0.6 : 1,
});

const LoadMoreButton = ({ onClick, disabled, isLoading }) => {
  const { t } = useTranslation();
  return (
    <div style={wrapperStyle}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        style={buttonStyle(isLoading)}
      >
        {isLoading ? t("Loading...") : t("Load More")}
      </button>
    </div>
  );
};

export default LoadMoreButton;
